/* ============
 * PaymentKind Module
 * ============
 */

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    paymentName: [],
    paymentKindsAndTypes: [],
  },
  actions,
  mutations,
  getters,
};
